import { isWithinInterval } from "date-fns";
import { useBalances } from "@rentablo/api/apiv1";
import { convertBalancesToChartData } from "@helpers/charts";

interface Params {
  accountId: number;
  startDate?: Date;
  endDate?: Date;
  displayCurrency?: string;
}

export const useAccountChartData = ({
  accountId,
  startDate,
  endDate,
  displayCurrency,
}: Params) => {
  const { data, isFetching, isPending } = useBalances({
    id: [accountId],
    displayCurrency,
  });

  const chartData = convertBalancesToChartData(data?.dateValuePairs);
  const chartDataInRange = chartData.filter(({ date }) => {
    if (!startDate || !endDate) return true;
    return isWithinInterval(date, { start: startDate, end: endDate });
  });

  return {
    data: chartDataInRange,
    isFetching,
    isPending,
  };
};
